import { ListItem } from '../../../ListItem'

import { RentalPortalApplicantsStageFilterListItemContent } from './RentalPortalApplicantsStageFilterListItemContent'

function RentalPortalApplicantsStageFilterListItem(props) {
  return (
    <ListItem
      {...props}
      Content={RentalPortalApplicantsStageFilterListItemContent}
    />
  )
}

export default RentalPortalApplicantsStageFilterListItem
